import React, { useEffect, useLayoutEffect, useRef } from "react";
import { Outlet, useLocation, useNavigationType } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartSheet } from "@/components/CartSheet";
import { SEO_MAP, setSeo } from "@/lib/seo";
import { HomeShell } from "@/components/home/HomeShell";

const ScrollToTop = () => {
  const { pathname, key } = useLocation();
  const navigationType = useNavigationType();
  const homePositions = useRef(new Map());
  const previousPath = useRef(null);
  useLayoutEffect(() => {
    const pathChanged = previousPath.current !== pathname;
    previousPath.current = pathname;
    const saved = homePositions.current.get(key);
    let frame = null;
    if (pathname === "/" && navigationType === "POP" && saved !== undefined) {
      // Reapply after the route DOM is laid out; SPA height changes can defeat
      // the browser's native history position even without an explicit reset.
      const restore = () => window.scrollTo({ top: saved, behavior: "instant" });
      restore();
      frame = window.requestAnimationFrame(restore);
    } else if (pathChanged && (pathname !== "/" || navigationType !== "POP")) {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
    const remember = () => { if (pathname === "/") homePositions.current.set(key, window.scrollY); };
    window.addEventListener("scroll", remember, { passive: true });
    return () => {
      window.removeEventListener("scroll", remember);
      if (frame !== null) window.cancelAnimationFrame(frame);
    };
  }, [pathname, key, navigationType]);
  return null;
};

const SeoManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // Only manage known static routes; dynamic pages (legal, product) set their own SEO.
    const meta = SEO_MAP[pathname];
    if (meta) setSeo({ ...meta, path: pathname });
  }, [pathname]);
  return null;
};

export const Layout = () => {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen flex flex-col bg-[#FBF9F6]">
      <ScrollToTop />
      <SeoManager />
      {pathname === "/" ? <HomeShell /> : <><Header />
      <main id="site-content" tabIndex={-1} className="flex-1 rh-inner-main">
        <Outlet />
      </main>
      <Footer /></>}
      <CartSheet />
    </div>
  );
};
